import React from "react";
import { ArrowRight } from "lucide-react";
import { processSteps } from "../mock";
import { Button } from "./ui/button";

const Process = () => {
  return (
    <section className="py-24 bg-brand-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04]" style={{
        backgroundImage:
          "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
        backgroundSize: "32px 32px",
      }} />
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="max-w-2xl">
          <div className="text-[12px] tracking-[0.3em] uppercase text-accent2 font-semibold">
            So arbeiten wir
          </div>
          <h2 className="mt-3 font-display text-[36px] md:text-[46px] leading-tight font-extrabold">
            In 4 Schritten zur sorgenfreien Verwaltung.
          </h2>
          <p className="mt-5 text-brand-200 leading-relaxed">
            Ein einfacher, transparenter Prozess, damit Sie von Anfang an genau wissen, was Sie erwartet.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {processSteps.map((p, i) => (
            <div key={p.step} className="relative group">
              <div className="font-display text-[80px] leading-none font-extrabold text-white/10 group-hover:text-accent2/40 transition-colors">
                {p.step}
              </div>
              <div className="mt-2 font-display font-bold text-xl">{p.title}</div>
              <p className="mt-3 text-brand-200 text-[14px] leading-relaxed">{p.text}</p>
              {i < processSteps.length - 1 && (
                <div className="hidden lg:block absolute top-8 -right-3 w-6 h-[2px] bg-white/20" />
              )}
            </div>
          ))}
        </div>

        <div className="mt-14 flex justify-center">
          <Button
            asChild
            className="bg-white text-brand-900 hover:bg-brand-50 font-semibold rounded-full h-14 px-7 text-[15px] shadow-lg shadow-black/20"
          >
            <a href="/#contact" data-testid="process-cta-button" className="inline-flex items-center gap-2">
              Unverbindliches Angebot anfragen <ArrowRight className="w-4 h-4" />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Process;
